/**
 * Pastille d'un score global de test, dans les tables de campagne.
 *
 * Palier du score, en une seule teinte : ces pourcentages n'ont pas de pôle
 * « mauvais » à colorer en rouge — un matching bas dit une distance au
 * référentiel, pas un échec du candidat.
 *
 * Trois paliers plutôt qu'un dégradé continu : le niveau se lit d'un coup
 * d'œil, et chaque couple fond/texte tient le contraste AA (≥ 4,5:1). Fond
 * mélangé au blanc, pas au transparent : le survol de ligne ne doit pas changer
 * la teinte de la pastille.
 */
export const TEINTES_PASTILLE = {
  haute: "bg-primary text-primary-foreground",
  moyenne: "bg-[color-mix(in_srgb,var(--primary)_35%,white)] text-foreground",
  basse: "bg-muted text-foreground",
  /** Signal défavorable (PC Fit « Éloigné ») : distinct de l'absence de signal. */
  alerte: "bg-etat-alerte-surface text-etat-alerte-contenu",
} as const;

export type Pastille = { texte: string; classes: string };

/** Score sur 100, en paliers 70 / 40. */
export function pastillePourcentage(score: number): Pastille {
  // Sur la valeur affichée : un 69,6 lu « 70 % » doit avoir la pastille de 70.
  const arrondi = Math.round(score);
  return {
    texte: `${arrondi} %`,
    classes:
      arrondi >= 70
        ? TEINTES_PASTILLE.haute
        : arrondi >= 40
          ? TEINTES_PASTILLE.moyenne
          : TEINTES_PASTILLE.basse,
  };
}

export function PastilleScore({ pastille }: { pastille: Pastille }) {
  return (
    <span
      className={`inline-block min-w-14 rounded-pastille px-2 py-0.5 text-center text-xs font-semibold tabular-nums ${pastille.classes}`}
    >
      {pastille.texte}
    </span>
  );
}
